import { useContext, useEffect } from 'react';

import { LoadSavedQuotationsCard, QuotationInfoContext, QuotationStep } from '../../../shared';
import { LOADING_SAVED_QUOTATIONS_STATES } from '../../../shared/interfaces/loading-saved-quotations-states-enum';

import './index.css';

export const LoadSavedQuotation = () => {
  const {
    loadSaveQuotationState,
    setLoadSaveQuotationState,
    setLoadingSavedQuotation,
    setCurrentStep,
  } = useContext(QuotationInfoContext);

  useEffect(() => {
    setLoadSaveQuotationState(LOADING_SAVED_QUOTATIONS_STATES.INIT_LOADING);
  }, []);
 
  useEffect(() => {
    if(loadSaveQuotationState === LOADING_SAVED_QUOTATIONS_STATES.STEP_THREE_DATA_FILLED) {
      setLoadSaveQuotationState(LOADING_SAVED_QUOTATIONS_STATES.FINISH_LOADING);
      setLoadingSavedQuotation(false);
      setCurrentStep(QuotationStep.THREE);
    }
  }, [loadSaveQuotationState]);

  return <LoadSavedQuotationsCard />;
};
